import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
} from "@/utils/type-vaildator";
import api from "./api";

export interface PayCreateOneBuyRequest {
  sku: string;
  cancelSub?: string;
  teamCode: string;
  email: string;
  successJumpUrl: string;
  failJumpUrl: string;
}

interface PayCreateOneBuyResponse {
  session_id: string;
  url: string;
  amount: number;
  currency: string;
  status: string;
}

export class PayCreateOneBuyData {
  @Required("url cannot be empty")
  @IsString("url must be a string")
  url: string;
}

const transformAndValidateData = (
  response: PayCreateOneBuyResponse
): PayCreateOneBuyData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, PayCreateOneBuyData);
  } catch (error) {
    console.error("Pay create one buy data validation failed:", error.message);
    throw error;
  }
};

/** 创建一次购买（积分包） */
export const payCreateOneBuy = async ({ sku, teamCode, email, cancelSub, successJumpUrl, failJumpUrl }: PayCreateOneBuyRequest) => {
  const res = await api.get<PayCreateOneBuyResponse>('/pay/create/one_buy', {
    sku,
    email,
    team_code: teamCode,
    cancel_sub: cancelSub,
    success_jump_url: successJumpUrl,
    fail_jump_url: failJumpUrl,
  });
  const data = transformAndValidateData(res.data);
  return data;
}